<template>
	<div id="app">
		<img src="/logo.png" width="200px" style="margin-top: 2em" />
		<div v-if="loading" style="height: 40vh; display: flex; align-items: center; justify-content: center">
			<div style="display: flex; flex-direction: column; align-items: center">
				<OrbitSpinner :size="55" color="#431266" />
				<br /><br />
				<center>Loading..Please wait..</center>
			</div>
		</div>
		<invoice-details
			v-if="show"
			:details="details"
			:name="name"
			:endpoint="endpoint"
			:invoiceNumber="invoiceNumber"
			@methodChosen="methodChosen"
			@paymentDone="paymentDone"
			@nonceLoaded="brainTreeSubmit"
		/>
		<p v-if="error" style="margin-top: 10%">Error: invalid Link. Please contact us.</p>
		<div v-if="paymentfailed" style="margin-top: 10%">
			<p>Your payment has failed. Please try again.</p>
			<a :href="retryURL"><button v-if="showbutton" style="margin-top: 3em" class="button">Try Again</button></a>
		</div>
		<div v-if="thankyou" style="margin-top: 5%; width: 100%">
			<p>We have received your payment.</p>
			<p> {{ invoiceNumber ? "Invoice Number:" + invoiceNumber : ""}} {{ payment_ref ? "Payment Reference: " + payment_ref : ""}}</p>
			<p>You may now close this window.</p>
		</div>
		<div v-if="paying" style="margin-top: 5%; width:100%">
			We are processing this invoice.  We may contact you if your payment fails.
		</div>
		<div v-if="paid" style="margin-top: 5%; width: 100%">
			<p>This invoice has been paid. Thank you.</p>
		</div>
		<div v-if="!thankyou && !paid" class="disclaimer">
			<em
				>All payment are performed under an encrypted network and a secure method of data transmission provided by our payment partners. When
				processing payment, your details are automatically redirected toward payment provider's servers which handle the all operation while meeting
				the latest security requirements.</em
			>
		</div>
		<small style="margin:5em"><center>Build version 123979</center></small>
	</div>
</template>

<script>
	import { OrbitSpinner } from "epic-spinners";
	import InvoiceDetails from "./InvoiceDetails.vue";
	export default {
		name: "app",
		components: {
			InvoiceDetails,
			OrbitSpinner,
		},
		data() {
			return {
				loading: true,
				thankyou: false,
				encryptedId: null,
				invoiceNumber: null,
				payment_ref: null,
				error: false,
				details: {},
				show: false,
				paid: false,
				paying: false,
				paymentfailed: false,
				errormsg: "",
				name: "",
				showbutton: true,
				showref:false,
				version: "v1"

			};
		},
		mounted() {
			let urlParams = new URLSearchParams(window.location.search);

			let c = urlParams.get('c');
			this.encryptedId = c;
			let page = urlParams.get('page');
			let inv=urlParams.get('inv');
			this.invoiceNumber = inv;
			let ref=urlParams.get('ref');
			this.payment_ref = ref;
			let v = urlParams.get('v');
			this.version = v;
			console.log("version", v);
			if(!c && !page) {
				this.loading = false;
				this.error = true;
				return;
			}

			if (page=="thankyou") {
				this.loading = false;
				this.thankyou = true;
				return;
			}

			if (page == "paymentfailed") {
				this.showbutton=false;
				this.loading = false;
				this.paymentfailed = true;
				if(this.encryptedId) {
					this.showbutton=true;
				}
				return;
			}

			console.log("link", this.endpoint + "get/" + this.encryptedId + "?v=" + this.version)
			axios
				.get(this.endpoint + "get/" + this.encryptedId + "?v=" + this.version)
				.then((response) => {
					if ("error" in response.data) {
						this.error = true;
						this.loading = false;
					}
					this.details = response.data.invoice;
					this.invoiceNumber = response.data.invoice.invoice_number;
					this.name = response.data.name;
					this.loading = false;
					if (response.data.status == "paid") {
						this.paid = true;
					} else if (response.data.status == "paying") {
						this.paying=true;
					} else {
						this.show = true;
					}
				})
				.catch((error) => {
					console.log(error.response);
					this.loading = false;
				});
		},
		methods: {
			methodChosen(x) {
				if (x == "QFPay") {
					this.loading = true;
					this.show = false;
					axios
						.get(this.endpoint + "create_qfpay_checkout/" + this.encryptedId + "?v=" + this.version)
						.then(({ data }) => {
							console.log(data);
							window.location.href = data.url;
						})
						.catch((error) => {
							alert("error occured");
						});
					return;
				}
				alert(x);
				return;
			},
			paymentDone(method, reference) {
				this.loading = true;
				this.show = false;
				axios
					.get(this.endpoint + "preprocess_paypal?c=" + this.encryptedId + "&ref=" + reference + "&v=" + this.version)
					.then((response) => {
						this.payment_ref = reference;
						this.show = false;
						this.thankyou = true;
						this.loading = false;
					})
					.catch((error) => {
						console.log(error.response);
					});
			},
			brainTreeSubmit(payload, save, allow) {
				this.loading = true;
				this.show = false;
				axios
					.post(this.endpoint + "create_bt_transaction", {
						payload: payload,
						sub_id: this.encryptedId,
						saveCard: save,
						allowCharge: allow,
						v: this.version,
					})
					.then((response) => {
						if (response.data.status == "OK") {
							this.loading = false;
							this.payment_ref = response.data.ref;
							this.show = false;
							this.thankyou = true;
							this.showref = true;
						} else {
							this.loading = false;
							this.show = false;
							this.paymentfailed = true;
							this.retry=this.params;
							this.errormsg = response.data.message;
						}
					});
			},
		},
		computed: {
			endpoint() {
				if(window.location.href.includes('localhost')) {
					return"http://localhost:3000/payments/"
				} else {
					return 'https://healthyfood.app/payments/'
				}
			},
			retryURL() {
				return "https://payments.eatologyasia.com/?c=" + this.encryptedId + "&v=" + this.version;
			},

		}
	};
</script>

<!-- CSS libraries -->
<style src="normalize.css/normalize.css"></style>

<!-- Global CSS -->
<style>
	code {
		font-family: Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace, serif;
		font-size: 0.9em;
		white-space: pre-wrap;
		color: #595a5c;
	}

	code::before,
	code::after {
		content: "`";
	}
</style>

<!-- Scoped component css -->
<!-- It only affect current component -->
<style scoped>
	.disclaimer {
		margin-top: 10%;
		padding: 5%;
	}

	#app {
		max-width: 600px;
		text-align: center;
		margin: auto;
		color: #595a5c;
	}
	.button {
		background-color: #431266;
		color: white;
		margin: 10px;
		text-align: center;
		padding: 10px;
		border-radius: 20px;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/App.vue